import type { ITeamMembers } from '@/interfaces'

export class TeamMembers implements ITeamMembers {
	role: string
	members: string[]

	constructor({ role, members }: ITeamMembers) {
		this.role = role
		this.members = members
	}
}
